import { Search } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgSearchAlternate = mkIcon(Search);